module.exports = __webpack_public_path__ + "img/img32.12d44ff6.png";